module.exports = __webpack_public_path__ + "assets/img/app-5.964a55ea.png";